import { inject, Injectable } from '@angular/core'

import { Observable } from 'rxjs'
import { debounceTime, map, take, tap } from 'rxjs/operators'

import { CoreAuthService } from '@core/auth/services/core-auth-service'
import { Store } from '@ngrx/store'
import { goToPage } from '@core/ngrx-router/state/actions/ngrx-router.actions'

@Injectable({
  providedIn: 'root'
})
export class LoginGuard {
  private readonly _ionicAuth: CoreAuthService = inject(CoreAuthService)
  private readonly _store: Store = inject(Store)

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this._ionicAuth.token$.pipe(
      debounceTime(600),
      tap((tokenResponse) => tokenResponse?.isValid(0) && this._store.dispatch(goToPage({}))),
      map((tokenResponse) => !tokenResponse?.isValid(0)),
      take(1)
    )
  }
}
